import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../../../../../../../../../components/CiscoUi';
import UserRoleGuard from '../../../../../../../../../../../../auth/components/UserRoleGuard/container.ts';
import { REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER } from './constants.ts';

export type ShowDisabledTemplatesFilterProps = {
  isShowingDisabledTemplates: boolean;
  onChange: VoidFunction;
};

export const ShowDisabledTemplatesFilter = ({
  isShowingDisabledTemplates,
  onChange,
}: ShowDisabledTemplatesFilterProps) => {
  const { t } = useTranslation();

  return (
    <UserRoleGuard
      requiredRoles={REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER}
    >
      <Checkbox
        checked={isShowingDisabledTemplates}
        label={t('virtualMachines.add.filters.vmTemplates.showDisabled')}
        onChange={onChange}
        name="vm-templates-filter-toggle"
      />
    </UserRoleGuard>
  );
};
